import React, { useEffect } from 'react';
import axios from 'axios';
import { translations } from '../Text/translations';
import phoneCallIcon from '../../assets/icons/phone-call.svg';

const NetflixError = ({ currentLang, nickname, mobilenowid, emailnowid, fsa }) => {
/*  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let source = urlParams.get('src');
    source = source ? "_" + source : "";
    const paramName = "Nowtv_getstarted" + source;
  
    axios.get(`https://nowplayer.now.com/livechat/renderLiveChatButton`, {
      params: {
        m_n: paramName,
        l: currentLang,
        e_s: "nowtv.now.com"
      }
    }).then(response => {
      const liveChatBtn = document.getElementById('livehcat-btn');
      if (liveChatBtn && response.data.liveChatButtonHtml) {
        const oldHtml = liveChatBtn.innerHTML;
        liveChatBtn.innerHTML = response.data.liveChatButtonHtml;
        const linkElement = liveChatBtn.querySelector('a');
        if (linkElement) {
          linkElement.innerHTML = oldHtml;
          // Set up the click event handler here
          linkElement.addEventListener('click', (e) => {
            e.preventDefault(); // prevent the default action
            // Open the chat box in a new window
            window.open(`https://nowplayer.now.com/livechat/openLiveChatBox?m_n=${paramName}&l=${currentLang}&e_s=nowtv.now.com`, '_blank');
          });
        }
      }
    }).catch(e => {
      alert(e);
    });
  }, [currentLang]);
*/
  return (
    <>
      <div className="message">
        <h4>{translations[currentLang].netflixSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].netflixSubjectGreeting2}</h4>
        <p>{translations[currentLang].netflixErrorP}</p>
        <p>{translations[currentLang].netflixErrorP2}</p>
      </div>
      <div className="chat-options">
      {/* <div class="item" id="livehcat-btn">
            <a 
              onClick={(e) => {
                e.preventDefault();
                const lang = currentLang === 'en' ? 'en' : 'zh';
                const url = fsa 
                  ? `https://livechathost.pccw.com/nowtv/chat/?c_t=NTK&c_id=${fsa}&m_n=Nowtv_netflix&n_n=Guest&l=${lang}&e_s=nowtv.now.com&c_s=now%20TV`
                  : `https://livechathost.pccw.com/nowtv/chat/?c_t=NTK&c_id=guest&m_n=Nowtv_netflix&n_n=Guest&l=${lang}&e_s=nowtv.now.com&c_s=now%20TV`;
                window.open(url, '_blank', 'width=410, height=550, location=0, resizeable=0, status=0, toolbar=0, titlebar=0, scrollbars=0');
              }}
            ><div className="img-wrap"><img src={`${theme_url_images}/netflix/msg-dialog.svg`} alt="" className="message" /></div>
            <h4>{translations[currentLang].chatUs}</h4>
            </a>
          </div> */}
        <div className="item">
          <a href="tel:1833888">
            <div className="img-wrap"><img src={phoneCallIcon} alt="" className="phone" /></div>
            <h4>1833 888</h4>
          </a>
        </div>
      </div>
    </>
  );
};

export default NetflixError;